<template>
    <aside class="fr">
        <MusicPlayer></MusicPlayer>
        <div class="split"></div>
        <div class="weather hide">
            <span class="title">万千气象</span>
            <div class="line"></div>
        </div>
        <div class="split"></div>
        <HotList></HotList>
        <div class="split"></div>
        <Tags></Tags>
        <div class="split"></div>
        <div class="friendLink hide">
            <span class="title">友情链接</span>
            <div class="line"></div>
            <div class="split"></div>
        </div>
    </aside>
</template>

<script>
import MusicPlayer from '../components/MusicPlayer'
import HotList from '../components/HotList'
import Tags from '../components/Tags'
export default {
    components:{ HotList,Tags,MusicPlayer}
}
</script>


// WEBPACK FOOTER //
// src/components/AsideBox.vue